<template>
    <div id="testing-events" class="page-layout__inner">
        <div :class="'page-layout__filter' + (filterSettings.visible ? '' : ' w-auto')">
            <section :class="'section  section--shadow-0  section--p-0' + (filterSettings.visible ? ' h-100' : '')">
                <button @click="filterSettings.visible = true" :class="'section__filter-btn' + (filterSettings.visible ? ' section__filter-btn--hidden' : '')">
                    <svg class="section__filter-icon">
                        <use xlink:href="#icon__filter"></use>
                    </svg>
                </button>
                <div :class="'section__filter' + (filterSettings.visible ? '' : ' section__filter--hidden')">
                    <div class="section__header">
                        <h3 class="section__title">
                            <svg class="section__filter-icon">
                                <use xlink:href="#icon__filter"></use>
                            </svg>
                            {{ getTranslation('filter')}}
                        </h3>

                        <div class="section__controls">
                            <div class="section__controls-group">
                                <a @click="filterSettings.visible = false" class="btn  btn--xs  btn--control  js-filterHider" href="javascript:void(0)">{{ getTranslation('hide') }}</a>
                                <a class="btn  btn--xs  btn--control" href="javascript:void(0)" @click="resetFilter()">{{ getTranslation('reset') }}</a>
                            </div>
                        </div>
                    </div>
                    <div class="section__body">
                        <div class="form__group">
                            <label class="form__label  form__label--block">{{ getTranslation('view') }}</label>

                            <label class="radio  radio--inline">
                                <input class="radio__input" type="radio" v-model="calendarView" name="radioBtnSample1">
                                <span class="radio__indicator  radio__indicator--inline"></span>
                                <span class="radio__label">{{ getTranslation('eventTableView') }}</span>
                            </label>

                            <label class="radio  radio--inline">
                                <input class="radio__input" v-model="calendarView" type="radio" value="true" name="radioBtnSample1">
                                <span class="radio__indicator  radio__indicator--inline"></span>
                                <span class="radio__label">{{ getTranslation('eventCalendarView') }}</span>
                            </label>
                        </div>
                        <div class="form__group">
                            <label class="form__label  form__label--block">{{ getTranslation('office') }}</label>
                            <v-select
                                    :options="offices"
                                    :reduce="option=>option.id"
                                    label="title"
                                    :placeholder="getTranslation('selectFromList')"
                                    v-model="filterForm.officeId"
                            />
                        </div>
                        <div class="form__group">
                            <label class="form__label  form__label--block">{{ getTranslation('type') }}</label>
                            <div class="list-group">
                                <a @click="selectFilter(option.id)" v-for="option in formOptions" class="list-group-item list-group-item-action" :class="{'active' : filterType === option.id}" href="javascript:void(0)">
                                    {{ option.title }}
                                </a>
                            </div>
                        </div>
                        <div v-if="!calendarView" class="form__group">
                            <label class="form__label  form__label--block">{{getTranslation('byDate')}}</label>
                            <div class="form__tillfrom-row">
                                <div>
                                    <date-picker v-model="filterForm.dateFrom"></date-picker>
                                </div>
                                <div class="form__tillfrom-sep"></div>
                                <div>
                                    <date-picker v-model="filterForm.dateTo"></date-picker>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div v-if="!calendarView" class="page-layout__content">
            <p class="page-layout__descr text">{{ getTranslation('foundWithQuantity',pagination.total) }}</p>
            <div class="page-layout__group">
                <section class="section">
                    <div class="section__body">
                        <table class="table-3 table-borderless">
                            <thead class="table-3__head">
                                <tr class="table-3__row">
                                    <th class="table-3__cell  table__hcell" style="width: 25%">{{ getTranslation('state') }}</th>
                                    <th class="table-3__cell  table__hcell" style="width: 23%">{{ getTranslation('appName') }}</th>
                                    <th class="table-3__cell  table__hcell" style="width: 10%">{{ getTranslation('office') }}</th>
                                    <th class="table-3__cell  table__hcell" style="width: 20%">{{ getTranslation('dateAndTimeOccur') }}</th>
                                    <th class="table-3__cell  table__hcell" style="width: 8%">{{ getTranslation('status') }}</th>
                                    <th class="table-3__cell  table__hcell" style="width: 0.2%"></th>
                                </tr>
                            </thead>
                            <tbody class="table-3__body">
                                <tr v-for="item in  items" v-bind:key="item.id" class="table-3__row">
                                  <td class="table-3__cell">
                                    {{ item.stateText }}
                                  </td>
                                    <td class="table-3__cell">
                                        <router-link :to="{ name: 'api.application.get', params: { id: item.application.id },query:{tab:'events'} }">{{ item.application.title }}</router-link>
                                    </td>
                                    <td class="table-3__cell">
                                        <router-link :to="{ name: 'api.office.get', params: { id: item.office.id } }"> {{item.office.title}}</router-link>
                                    </td>
                                    <td class="table-3__cell">
                                        {{ item.eventDateFormat }}
                                    </td>
                                    <td class="table-3__cell">
                                        <span v-if="item.eventStatus === 'EVENT_FAILED'" class="badge badge--accent">{{ getTranslation('EVENT_FAILED') }}</span>
                                        <span v-else-if="item.isFuture">{{ getTranslation('testing_future') }}</span>
                                        <span v-else-if="item.isPassed">{{ getTranslation('testing_past') }}</span>
                                        <span v-else-if="item.isActive">{{ getTranslation('testing_active') }}</span>
                                    </td>
                                    <td class="table-3__cell">
                                        <ActionsComponent
                                                :options="{
                                                   viewPage:hasPermission('api.testing.event.get')
                                                }"
                                                :has-edit="false"
                                                :has-delete="false"
                                                v-on:viewPage="()=>{$router.push({name:'api.testing.event.get',params:{id:item.id}})}"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>
            </div>
            <div class="page-layout__pagination" v-if="pagination.total && pagination.lastPage > 1">
                <pagination :pagination="pagination" @change="()=>{fetchEvents();this.$scrollTo('#testing-event');}" v-model="filterForm.page"></pagination>
            </div>
        </div>
        <div v-if="calendarView" class="page-layout__content">
            <CalendarComponent
                    v-if="calendarView"
                    :subject-id="isOffice ? filterForm.officeId : null"
                    :subject-type="isOffice ? 'office' : 'all'"
                    :filter-params="{filter:filterType}"
                    :calendar-options="{
                            defaultView: 'dayGridMonth',
                            header: {
                                left: 'prevYear,prev,next,nextYear, today',
                                center: 'title',
                                right: 'dayGridMonth,timeGridWeek,timeGridDay'
                            },
                            businessHours:false,
                            eventCreate:false,
                            calendarWeekends: true,
                            tableView: false,
                            allDayDefault: false,
                            editable: false,
                            eventOverlap: true,
                            displayEventEnd: true,
                            droppable: false,
                            windowResizeDelay: 100,
                            eventBackgroundColor:'#d7f0f7'
                         }"
                    :active="(calendarView == 'true' || calendarView)"
            />
        </div>
    </div>
</template>

<script>
    import testActionsMixin from "./mixin/testingEventAction";
    import CalendarComponent from "../../../components/CalendarComponent";
    export default {
        name: "Index",
        mixins: [testActionsMixin],
        components: {  CalendarComponent },
        data() {
            return {
                filterSettings: {
                    visible: true,
                    reset: false,
                },
                formOptions: [],
                items: [],
                pagination: {
                    total: '',
                    lastPage: '',
                    currentPage: ''
                },
                filterForm: {
                    page: Number.parseInt( this.$route.query.page ) || 1,
                    filter: this.$route.query.filter || '',
                    officeId: null,
                    dateFrom: null,
                    dateTo: null,
                },
                filter: this.$route.query.filter || '',
                calendarView: true,
                isOffice: false,
            }
        },
        updated() {
            this.setHeadings( {
                title: this.getTranslation( 'events' )
            } );
        },
        computed: {
            filterType() {
                return this.filter;
            }
        },
        watch: {
            'filterForm.filter'( val ) {
                if ( !this.calendarView && !this.filterSettings.reset )
                    this.fetchEvents();

                if ( !val )
                    this.filterSettings.reset = false;
            },
            'calendarView'( val ) {
                if ( !val )
                    this.fetchEvents();
            },
            'filterForm.officeId'( val ) {
                if ( !this.calendarView && !this.filterSettings.reset )
                    this.fetchEvents();

                if ( val ) {
                    this.isOffice = true;
                }
                else {
                    this.isOffice = false;
                    this.filterSettings.reset = false;
                }
            },
            'filterForm.dateFrom'( val ) {
                if ( !this.calendarView && !this.filterSettings.reset )
                    this.fetchEvents();

                if ( !val )
                    this.filterSettings.reset = false;
            },
            'filterForm.dateTo'( val ) {
                if ( !this.calendarView && !this.filterSettings.reset )
                    this.fetchEvents();

                if ( !val )
                    this.filterSettings.reset = false;
            },
        },
        created() {
            this.fetchFormOptions().then( () => {
                if ( !this.calendarView )
                    this.fetchEvents();
            } );
        },
        methods: {
            fetchEvents() {
                let params = { ...this.filterForm };
                return this.axios.get( this.$config.urls.event.fetchEvents.url, { params: params } ).then( response => {
                    this.items = response.data.data.items;
                    this.pagination.currentPage = response.data.data.activePage;
                    this.filterForm.page = response.data.data.activePage;
                    this.pagination.total = response.data.data.totalItemsCount;
                    this.pagination.lastPage = response.data.data.pages;
                } ).catch(()=>{});
            },

            async cancelTestingEvent( eventId ) {
                this.comment = await Swal.fire( {
                    title: '<label class="form__label reject--comment-label">' + this.getTranslation( 'eventRejectComment' ) + '<span class="required">*</span></label>',
                    input: 'textarea',
                    inputPlaceholder: this.getTranslation( 'writeEventRejectComment' ),
                    inputValidator: ( value ) => {
                        if ( !value ) {
                            return this.getTranslation( 'writeEventRejectComment' );
                        }
                    },
                    showCancelButton: true,
                    cancelButtonText: this.getTranslation( 'cancel' )
                } );

                if ( this.comment.value ) {
                    this.rejectEvent( eventId, { comment: this.comment.value } ).then( () => {

                        this.fetchEvents();

                        Swal.fire(
                            this.getTranslation( 'cancelled' ),
                            this.getTranslation( 'eventCancelledMsg' ),
                            'success'
                        );
                    } ).catch(()=>{});
                }
            },

            selectFilter( filter ) {
                this.filterForm.filter = filter;
                this.filter = filter;
            },
            fetchFormOptions() {
                return this.fetchEventFormOptions().then( response => {
                    this.formOptions = response;
                } ).catch(()=>{});
            },
            resetFilter() {
                this.filterSettings.reset = true;
                this.$router.replace( {
                    query: {}
                } ).catch( () => {
                } );
                this.filterForm.page = 1;
                this.filterForm.filter = '';
                this.filterForm.officeId = null;
                this.filterForm.dateTo = null;
                this.filterForm.dateFrom = null;
                this.filter = '';
                this.fetchEvents();
            }
        }
    }
</script>

<style scoped>
    .list-group-item-action {
        width: 100%;
        color: #303030;
        text-align: inherit;
    }


    .list-group-item.active {
        z-index: 2;
        color: #fff;
        background-color: #007bff;
        border-color: #007bff;
    }

    .page-layout__filter {
        -ms-flex-negative: 0;
        flex-shrink: 0;
        width: 300px;
    }
</style>
